export default "__VITE_ASSET__DK7gUrDu__"